import { render, staticRenderFns } from "./TranslationDraftForm.vue?vue&type=template&id=035d9564"
import script from "./TranslationDraftForm.vue?vue&type=script&lang=js"
export * from "./TranslationDraftForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports